import React, { useState, useEffect } from 'react'
import { Item } from '../../../common/snippets'
import { Box, Button, Table, TableBody, TableCell, TableHead, TableRow } from '@mui/material'
import * as sx from '../../../common/stylesInline/report_daily_branch'
import DropDownOA from '../../../common/dropDownOA'
import jsPDF from 'jspdf'
import autoTable from 'jspdf-autotable'
import { connect, useDispatch } from 'react-redux'
import { GetRechargePaymentModesListAll, updateAlertError, updateModal } from '../../../../store/common/common_action'
import * as id from '../reportId'
import moment from 'moment'
import { getBranchRechargeListAll, GetBranchRechargeListAllData } from '../../../common/jotaiState/dispatchRegisterReport'
import { focusElemnt, isEmpty, navigation3, removeDuplicatesFromArray } from '../../../common/helper'
import Datepicker from '../../../common/datePicker'
import { callAddFontRobotoBold } from '../../../common/font/Roboto-bold'
import { callAddFontRobotoMedium } from '../../../common/font/Roboto-Medium-normal'
import { RenderTable } from '../analysisReport/summmaryTable'
import { RenderTableExcel } from '../analysisReport/summaryTableExcel'
import ReactHtmlTableToExcel from 'react-html-table-to-excel'
import { columnDefs, excelHeader, excelHeaderColumn } from './constant'
import { makeTable } from '../analysisReport/pdfAutotable'
import { useAtom } from 'jotai'
import { globalLoaderAtom } from '../../../common/jotaiState/globalStateAtoms'
import { urls } from '../../../common/constants'
import { GetRequest, PostRequest } from '../../../common/api'

const reportname = 'Branch Recharge Report'

const BranchRechargeReport = (props) => {
  const {
    data: { common },
  } = props

  const [branchRechargeList] = useAtom(GetBranchRechargeListAllData)
  const [fromDate, setFromDate] = useState(moment(new Date()))
  const [toDate, setToDate] = useState(moment(new Date()))
  const [showTable, setShowTable] = useState(false)
  const [isPdfLoad, setIsPdfLoad] = useState(false)
  const { loginData, roleRights, RechargePaymentList } = common
  const {AllowViewAllBranchReport,AllowViewAllBranchOfCityReport}=roleRights?.Table1?.[0] || {}
  const [, getBranchRecharge] = useAtom(getBranchRechargeListAll)
  const dispatch = useDispatch()
  const [, setLoader] = useAtom(globalLoaderAtom)
  const currentDateTime = moment(new Date()).format('DD-MMM-YYYY HH:mm')

  const [sourceCityList, setSourceCityList] = useState([])
  const [tableData, setTableData] = useState([])
  const [resBranchCity, setResBranchCity] = useState([])
  const [selSourceCity, setSelSourceCity] = useState([])
  const [sourceBranchList, setSourceBranchList] = useState([])
  const [selSourceBranch, setSelSourceBranch] = useState()
  const [paymentModeList, setPaymentModeList] = useState([])
  const [selPaymentMode, setSelPaymentMode] = useState()
  const headerData = [
    {
      fromDate: fromDate.format('DD-MMM-YYYY'),
      toDate: toDate.format('DD-MMM-YYYY'),
      branchCity: selSourceCity?.CityName,
      branchName: selSourceBranch?.BranchName,
      rechargeMode: selPaymentMode?.RechargePaymentModeName,
      dataType: 'entry',
    },
  ]
  
  useEffect(() => {
    focusElemnt('fromDate')
  }, [])

  useEffect(() => {
    if (resBranchCity?.length > 0) {
      const branches = resBranchCity?.map((record) => ({
        BranchID: record.BranchID,
        BranchName: record.BranchName,
        CityID: record.CityID,
        CityName: record.CityName,
      }))
      const cities = resBranchCity?.map((record) => ({
        CityID: record.CityID,
        CityName: record.CityName,
      }))
      const cityList = removeDuplicatesFromArray(cities, 'CityID')
      const branchList = removeDuplicatesFromArray(branches, 'BranchID')
      setSourceCityList([{ CityName: 'All', CityID: 0 }, ...cityList])
      setSourceBranchList([{ BranchName: 'All', BranchID: 0 }, ...branchList])
    }
  }, [resBranchCity])
  useEffect(() => {
  if (sourceCityList?.length > 0) {
    if (AllowViewAllBranchOfCityReport === 0 && AllowViewAllBranchReport === 0) {
      const loginCity = sourceCityList.find((val) => val?.CityID === loginData?.intBranchCityID);
      setSelSourceCity(loginCity || sourceCityList[0]);
    } else if (AllowViewAllBranchOfCityReport === 1 && AllowViewAllBranchReport === 0) {
      const loginCity = sourceCityList.find((val) => val?.CityID === loginData?.intBranchCityID);
      setSelSourceCity(loginCity || sourceCityList[0]);
    } else {
      setSelSourceCity(sourceCityList[0]);
    }
  }
}, [sourceCityList, AllowViewAllBranchOfCityReport, AllowViewAllBranchReport]);

useEffect(() => {
  if (sourceBranchList?.length > 0) {
    if (AllowViewAllBranchReport === 0 && AllowViewAllBranchOfCityReport === 0) {
      const loginBranch = sourceBranchList.find((val) => val?.BranchID === loginData?.intBranchID);
      setSelSourceBranch(loginBranch || sourceBranchList[0]);
    } else {
      setSelSourceBranch(sourceBranchList[0]);
    }
  }
}, [sourceBranchList, AllowViewAllBranchReport, AllowViewAllBranchOfCityReport]);

  useEffect(() => {
    if (!isEmpty(roleRights)) {
      if (roleRights?.Table1?.[0]?.AllowViewAllBranchReport || loginData?.IsBranchAdmin || loginData?.IsMTPLAdmin || loginData?.IsAdmin) {
        const obj = {
          intUserID: 0,
          intCompanyID: loginData?.intCompanyID,
          intBranchID: 0,
          strBranchName: '',
          strBranchCode: '',
          intStateID: 0,
          intCityID: 0,
          intIsActive: -1,
        }
        PostRequest(urls.getBranchConfigOrEwbillinfo, obj).then((res) => {
          if (res.status === 'Success') {
            setResBranchCity(res?.Data?.Table)
          }
        })
      } else if (!roleRights?.Table1?.[0]?.AllowViewAllBranchOfCityReport && roleRights?.Table1?.[0]?.AllowBranchInchargeRights) {
        const obj = {
          CompanyID: loginData?.intCompanyID,
          CityID: loginData?.intCityID,
          UserID: loginData?.intUserID,
          BranchID: loginData?.intBranchID,
          Mode: 1,
        }
        GetRequest(urls.getReportBranchList, obj).then((res) => {
          if (res.status === 'Success') {
            setResBranchCity(res?.Data?.Table)
          }
        })
      } else {
        const obj = {
          intUserID: 0,
          intCompanyID: loginData?.intCompanyID,
          intBranchID: 0,
          strBranchName: '',
          strBranchCode: '',
          intStateID: 0,
          intCityID: loginData?.intCityID,
          intIsActive: -1,
        }
        PostRequest(urls.getBranchConfigOrEwbillinfo, obj).then((res) => {
          if (res.status === 'Success') {
            setResBranchCity(res?.Data?.Table)
          }
        })
      }
      dispatch(GetRechargePaymentModesListAll())
    }
  }, [roleRights, loginData, dispatch])

  const printClick = (isSave = false) => {
    setShowTable(false)
    setIsPdfLoad(true)
    const HeaderColumns = columnDefs.map((col) => {
      return {
        header: col.headerName,
        dataKey: col.field,
        xlCol: col.xlCol,
      }
    })
    const HeaderColumns1 = excelHeaderColumn.map((col) => {
      return { header: col.exportHead, dataKey: col.field, xlCol: col.xlCol }
    })
    jsPDF.API.events.push(['addFonts', callAddFontRobotoBold])
    jsPDF.API.events.push(['addFonts', callAddFontRobotoMedium])
    const doc = new jsPDF({ orientation: 'l', format: [1080, 1528], unit: 'px', compress: true })
    doc.setProperties({
      title: `${reportname}.pdf`,
      subject: reportname,
      author: 'Maven Tech Labs Pvt. Ltd.',
      keywords: 'maven tech, Cargo system, Branch Recharge',
      creator: 'MTLPL',
    })
    makeTable(doc, autoTable, HeaderColumns1, headerData, 1.2, reportname, loginData)
    makeTable(doc, autoTable, HeaderColumns, tableData, 1.2, reportname, loginData)

    const totalPages = doc.internal.getNumberOfPages()
    for (let i = 1; i <= totalPages; i++) {
      doc.setPage(i)
      const pageSize = doc.internal.pageSize
      const pageHeight = pageSize.height || pageSize.getHeight()
      const pageWidth = pageSize.width || pageSize.getWidth()
      const str = `Page : ${i} of ${totalPages}`
      doc.setFontSize(16)
      doc.setFont('Roboto', 'bold')
      doc.text(str, pageWidth - 20, pageHeight - 5, { align: 'right' })
    }

    setShowTable(false)
    setTimeout(() => {
      setLoader(false)
      const pdfUrl = doc.output('bloburl')
      document.getElementById('branchRechargeReport').data = pdfUrl
      // document.getElementById('branchRechargeReport').data = doc.output('datauristring', 'Branch Recharge.pdf')
    }, 2000)
    if (isSave) {
      doc.save(`Branch Recharge ${new Date().getTime()}.pdf`)
    }
  }

  const handleLoad = () => {
      const obj = {
        CompanyID: loginData?.intCompanyID,
        BranchID: selSourceBranch?.BranchID,
        frmDate: fromDate.format('YYYY-MM-DD'),
        ToDate: toDate.format('YYYY-MM-DD'),
        RechargeMode: selPaymentMode?.RechargePaymentModeID,
        CityID: selSourceCity?.CityID,
        UserID: loginData?.intUserID,
        AllowViewAllReport: 1,
      }
      getBranchRecharge(obj);
      setShowTable(true);
  }
  useEffect(()=>{
        setTableData(branchRechargeList)
  },[branchRechargeList])

  useEffect(() => {
    if (sourceCityList?.length > 0) {
      const loginCity = sourceCityList?.find((val) => val?.CityID === loginData?.intBranchCityID)
      if (loginCity) {
        setSelSourceCity(loginCity)
      } else {
        setSelSourceCity(sourceCityList[0])
      }
    }
  }, [sourceCityList])

  useEffect(() => {
    if (sourceBranchList?.length > 0) {
      const loginBranch = sourceBranchList?.find((val) => val?.BranchID === loginData?.intBranchID)
      if (loginBranch) {
        setSelSourceBranch(loginBranch)
      } else {
        setSelSourceBranch(sourceBranchList[0])
      }
    }
  }, [sourceBranchList])
  useEffect(() => {
    if (RechargePaymentList?.length > 0) {
      const list = [
        { RechargePaymentModeName: 'All', RechargePaymentModeID: 0 },
        ...RechargePaymentList,
        { RechargePaymentModeName: 'UPI-QR', RechargePaymentModeID: 7 },
      ]
      setPaymentModeList(list)
      setSelPaymentMode(list[0])
    }
  }, [RechargePaymentList])

  return (
    <>
      <Box sx={{ display: 'flex', justifyContent: 'start', alignItems: 'center', marginTop: '10px', padding: '0 24px' }}>
        <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: '10px' }} className="itemButtons">
          <Item sx={sx.itemsxGrow}>
            <DropDownOA
              id={id.selectCompnay}
              label={'Company Name'}
              defaultvalue={loginData.strCompanyName}
              disabled={true}
              onSelect={(val) => {
                setShowTable(false)
              }}
              width="100%"
            />
          </Item>
          <Item sx={sx.itemsxGrow} style={{ width: '140px' }} className="input--container bookingDatePicker">
            <Datepicker
              name={'from_collection_date'}
              value={fromDate}
              label={'From Recharge Date'}
              id={'fromRechargeDate'}
              dateChange={(date) => {
                setFromDate(date)
                setShowTable(false)
                focusElemnt('toRechargeDate')
              }}
              width="100%"
            />
          </Item>
          <Item sx={sx.itemsxGrow} style={{ width: '140px' }} className="input--container bookingDatePicker">
            <Datepicker
              id={'toRechargeDate'}
              label={'To Recharge Date'}
              value={toDate}
              dateChange={(date) => {
                setToDate(date)
                setShowTable(false)
                focusElemnt('branchCity')
              }}
              width="100%"
            />
          </Item>
          <Item sx={sx.itemsx}>
            <DropDownOA
              id={'branchCity'}
              label={'Branch City'}
              data={sourceCityList}
              defaultvalue={selSourceCity?.CityName}
              idKey={`CityID`}
              dataKey={`CityName`}
              minWidth="200px"
              nextId={'branchName'}
              prevId={`toRechargeDate`}
              disabled={AllowViewAllBranchReport === 0}
              onSelect={(obj) => {
                setSelSourceCity(obj)
                setShowTable(false)
                setSelSourceBranch(
                  removeDuplicatesFromArray(sourceBranchList, 'BranchID').filter(
                    (val) => val.CityID === obj?.CityID || obj?.CityID === 0 || val.BranchID === 0
                  )?.[0]
                )
              }}
            />
          </Item>
          <Item sx={{ ...sx.itemsx }}>
            <DropDownOA
              id={'branchName'}
              label={'Branch Name'}
              data={
                removeDuplicatesFromArray(sourceBranchList, 'BranchID').filter(
                  (val) => val.CityID === selSourceCity?.CityID || selSourceCity?.CityID === 0 || val.BranchID === 0
                ) || []
              }
              idKey={`BranchID`}
              dataKey={`BranchName`}
              defaultvalue={selSourceBranch?.BranchName}
              disabled={AllowViewAllBranchReport === 0 && AllowViewAllBranchOfCityReport === 0}
              minWidth="200px"
              nextId={'reachargeMode'}
              prevId={`branchCity`}
              onSelect={(val) => {
                setSelSourceBranch(val)
                setShowTable(false)
              }}
            />
          </Item>
          <Item sx={{ ...sx.itemsx }}>
            <DropDownOA
              id={'reachargeMode'}
              label={'Recharge Mode'}
              defaultvalue={selPaymentMode?.RechargePaymentModeName}
              value={selPaymentMode?.RechargePaymentModeName}
              data={paymentModeList || []}
              idKey={`RechargePaymentModeID`}
              dataKey={`RechargePaymentModeName`}
              minWidth="200px"
              nextId={'load_btn'}
              prevId={`branchName`}
              onSelect={(val) => {
                setSelPaymentMode(val)
                setShowTable(false)
              }}
            />
          </Item>
          <Item sx={{ ...sx.itemsx }} className="disabled-wrapper">
            <Button
              variant="contained"
              id={'load_btn'}
              sx={{ paddingY: '7px !important', height: '40px' }}
              className="btn btn-primary"
              onClick={handleLoad}
              onKeyDown={(e) => navigation3(e, 'pint_btn', 'reachargeMode', () => {})}
            >
              Load
            </Button>
          </Item>
          <Item sx={{ ...sx.itemsx }} className="disabled-wrapper">
            <Button
              variant="contained"
              id={'pint_btn'}
              sx={{ paddingY: '7px !important', height: '40px' }}
              className="btn btn-primary"
              onClick={() => (printClick(false))}
              onKeyDown={(e) => navigation3(e, 'branchRechExpToExlbtn', 'load_btn', () => {})}
            >
              Print
            </Button>
          </Item>
          <Box onKeyDown={(e) => navigation3(e, 'fromRechargeDate', 'pint_btn', () => {})}>
            <ReactHtmlTableToExcel
              id="branchRechExpToExlbtn"
              style={{ paddingY: '5px !important', height: '37px !important' }}
              className="btn btn-primary"
              table="table-anPaymentWiseSummaryReport-xls"
              filename={`Branch Recharge Report ${currentDateTime}`}
              sheet="tablexls"
              buttonText="Excel"
            />
          </Box>
        </Box>
      </Box>

      {showTable && (
        <Box sx={{ marginTop: '15px', padding: '0 24px' }}>
          <RenderTable header={columnDefs} data={tableData} key1={'fdierm'} key2={'sdiew'} key3={'orwex3'} />
          <Table id="table-anPaymentWiseSummaryReport-xls" size="small" aria-label="a dense table" style={{ display: 'none' }}>
            <TableHead style={{ fontWeight: 'bold' }}>
              <TableRow>
                <TableCell className="reportTD" style={{ fontSize: '24px', fontWeight: '500', textAlign: 'left' }} colSpan={7}>
                  <h3 style={{ paddingLeft: '17px' }}>Report For: Branch Recharge Report</h3>
                </TableCell>
                <TableCell className="reportTD" style={{ fontSize: '24px', fontWeight: '500', textAlign: 'right' }} colSpan={6}>
                  <h3 style={{ paddingLeft: '17px' }}>Company Name : {loginData?.strCompanyName}</h3>
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell colSpan={13}></TableCell>
              </TableRow>
              <TableRow style={{ color: 'white' }}>
                {excelHeader?.map((item, i) => (
                  <TableCell
                    className="ReportItemHead"
                    style={{ backgroundColor: '#e5f3ff', color: '#444444', fontSize: '20px', fontWeight: '600', textAlign: 'left' }}
                    colSpan={item.col}
                    key={i}
                  >
                    {item.value}
                  </TableCell>
                ))}
              </TableRow>
              <TableRow>
                <TableCell className="reportTD" style={{ fontSize: '20px', fontWeight: '600', textAlign: 'left' }} colSpan={2}>
                  {moment(fromDate).format('DD/MM/YYYY')}
                </TableCell>
                <TableCell className="reportTD" style={{ fontSize: '20px', fontWeight: '600', textAlign: 'left' }} colSpan={2}>
                  {moment(toDate).format('DD/MM/YYYY')}
                </TableCell>
                <TableCell className="reportTD" style={{ fontSize: '20px', fontWeight: '600', textAlign: 'left' }} colSpan={3}>
                  {selSourceCity?.CityName}
                </TableCell>
                <TableCell className="reportTD" style={{ fontSize: '20px', fontWeight: '600', textAlign: 'left' }} colSpan={3}>
                  {selSourceBranch?.BranchName}
                </TableCell>
                <TableCell className="reportTD" style={{ fontSize: '20px', fontWeight: '600', textAlign: 'left' }} colSpan={3}>
                  {selPaymentMode?.RechargePaymentModeName}
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell colSpan={13}></TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              <>
                <RenderTableExcel header={columnDefs} data={tableData} key1={'dskr1q'} key2={'sdi3m'} key3={'40dks3'} />
                <TableRow>
                  <TableCell colSpan={13}></TableCell>
                </TableRow>
              </>
            </TableBody>
          </Table>
        </Box>
      )}
      {!showTable && isPdfLoad && (
        <>
          <Box
            style={{
              width: '100%',
              paddingRight: '20px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'flex-end',
              marginTop: '10px',
            }}
          >
            <Button
              variant="contained"
              id="backBtn"
              sx={{ paddingY: '7px !important', height: '37px' }}
              className="btn btn-primary"
              onClick={() => {
                setShowTable(true)
                setIsPdfLoad(false)
              }}
              onKeyDown={(e) =>
                navigation3(e, id.fromDate, id.reportmainButton, () => {
                  setShowTable(true)
                  setIsPdfLoad(false)
                })
              }
            >
              Back
            </Button>
          </Box>
          <object
            id="branchRechargeReport"
            type="application/pdf"
            width={'100%'}
            height="440"
            title="MTLPL -Cargo System - Branch Recharge"
            aria-label="MTLPL -Cargo System -Branch Recharge"
            style={{ marginTop: '10px' }}
          ></object>
          : ( '' )
        </>
      )}
    </>
  )
}

const mapStateToProps = (data) => ({ data })
const mapDispatchToProps = { updateModal, updateAlertError }
export default connect(mapStateToProps, mapDispatchToProps)(BranchRechargeReport)
